import { MdLock } from "react-icons/md";
import { useSubscriptionGuard } from '../hooks/useSubscriptionGuard';
import { SUBSCRIPTION_BLOCKED_MESSAGE } from '../utils/hotelSubscription';

// Small lock notice shown on editable screens once the hotel's subscription has expired.
export default function SubscriptionReadOnlyNotice({ hotelId, className = "" }) {
    const { canEdit } = useSubscriptionGuard(hotelId);

    if (canEdit) {
        return null;
    }

    return (
        <div role="alert" className={`flex items-start gap-2 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800 ${className}`}>
            <MdLock className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
            <span className="min-w-0 break-words">{SUBSCRIPTION_BLOCKED_MESSAGE}</span>
        </div>
    );
}
